export const REGEXP = {
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  NAME: /^[A-Za-z\s]*$/ && /[A-Za-z]/ && /\s/,
  COMPANYNAME: /^[a-zA-Z,'.\-\s]+$/,
  POINTS: /^(?!0)([1-9]\d{0,3}|[1-4]\d{4}|50000)$/,
  REWARD_NAME: /^.{1,19}$/,
  REWARD_DESC: /^.{1,40}$/,
}
